import {useContext, useState} from "react";
import { motion } from "framer-motion";
import { dataContext } from "../../../context/context";
import './why.css';


function Why() {

    const { data, loading, error, isBY, isRU, isLocal, setModal  } = useContext(dataContext);
    const [showItems, setShowItems] = useState(false);

    let urlPrefix = "/images/";
    if (isLocal) urlPrefix = "https://sushi-tunec.com" + urlPrefix;



        const section = data.sectionsdata.find(s => s.nick === 'why');
        const paragraphs = section ? section.paragraphsdata : [];
        const block1 = paragraphs.find(p => p.nick === 'why1');
        const block2 = paragraphs.filter(p => p.nick === 'why2');


        return (
            <motion.section
                id="why"
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                viewport={{ once: true, amount: 0.1 }}
                transition={{ duration: 1, delay: 0.5 }}
                onAnimationComplete={() => {
                    setShowItems(true);
                }}
            >
                <div className="inner_block">
                    <div className="block1">

                        <h2>{section.title}</h2>

                        { block1.galerydata.length > 0 && (
                            <div className="galery">

                                {
                                    block1.galerydata.map((gal, index) => (

                                        <motion.div
                                            key={index}
                                            initial={{ opacity: 0, y: 10, scale: 0.5 }}
                                            animate={ showItems ? { opacity: 1, y: 0, scale: 1 } : {}}
                                            transition={{ delay: index * 0.3, duration: 0.3 }}
                                            className="galery_item">
                                            <img src={urlPrefix + gal.image} />

                                            {
                                                gal.text.map((line, index2) => (
                                                    <span key={index2}>{line}</span>
                                                ))
                                            }

                                        </motion.div>

                                    ))
                                }

                            </div>
                        )}


                    </div>
                    <div className="block2">

                        {
                            block2.map((par) => (

                                <div className="par">

                                    <h2>{par.title}</h2>
                                    {par.text}

                                    {
                                        par.ul.length > 0 && (
                                            <ul>
                                                { par.ul.map((li, index) => (

                                                    <li key={index}>{li}</li>

                                                ))
                                                }
                                            </ul>
                                        )
                                    }



                                </div>

                            ))
                        }

                        <div className="block2__footer">
                            <h3>Огромный опыт и передовые стандарты</h3>
                            Мы знаем как сделать ваш бизнес успешным

                            <button onClick={() => setModal(true)}>Отправить заявку</button>

                        </div>
                    </div>
                </div>
            </motion.section>
        )



}

export default Why;